const DEFAULT_EMBED_URL = 'https://diskuze.seznam.cz/v1';

function provideDefaultValue(value, defaultValue) {
	return typeof value === 'undefined' ? defaultValue : value;
}

function getLocalStorageData() {
	if (!window.localStorage) {
		return {};
	}

	const data = window.localStorage.getItem('_szn_discussion_');
	return JSON.parse(data) || {};
}

export default function createConfig(values) {
	if (values.embedUrl) {
		values.embedUrl = values.embedUrl.replace(/\/*$/g, '');
	}

	const config = {
		embedUrl: provideDefaultValue(values.embedUrl, DEFAULT_EMBED_URL),
		linksInNewTab: provideDefaultValue(values.linksInNewTab, false),
		allowScroll: provideDefaultValue(values.allowScroll, true),
		analyticsData: provideDefaultValue(values.analytics, {})
	};

	const masterOverride = getLocalStorageData();

	Object.assign(config, masterOverride);
	Object.freeze(config);

	return config;
}
